import { render, staticRenderFns } from "./yunshanfuDeclare.vue?vue&type=template&id=764aa629&scoped=true&"
import script from "./yunshanfuDeclare.vue?vue&type=script&lang=js&"
export * from "./yunshanfuDeclare.vue?vue&type=script&lang=js&"
import style0 from "./yunshanfuDeclare.vue?vue&type=style&index=0&id=764aa629&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764aa629",
  null
  
)

export default component.exports